/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import ChatIcon from '@mui/icons-material/Chat'
import { Badge, IconButton, Avatar, Tooltip } from '@mui/material/'
import { AuthBox, TitleName } from './stylesHT'
import { BiCalendar } from 'react-icons/bi'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { MenuSettings } from './Menus'
import MenuChat from './Menus/MenuChat'
import RouterHook from '../../../contexts/RouterHook'
import { IoHomeOutline } from 'react-icons/io5'
import { Services } from '../../../services'
import { ChatContext } from '../../../contexts/ChatContext'
import { useLocation } from 'react-router-dom'

export default function AuthActions() {
  const serverRouter = RouterHook()
  const location = useLocation()
  const { userUCtx } = React.useContext(UsuarioContext)
  const { sttChatCtx } = React.useContext(ChatContext)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [pageChat, setPageChat] = React.useState(false)
  const [countMensagens, setCountMensagens] = React.useState(0)

  const [modais, setModais] = React.useState({
    config: false,
    chat: false,
  })

  React.useEffect(() => {
    if (location.pathname.split('/')[1] === 'conversas') {
      setPageChat(true)
    } else {
      setPageChat(false)
    }
  }, [location.pathname])

  React.useEffect(() => {
    if (sttChatCtx.chatMNLE || sttChatCtx.chatMNLP) {
      setCountMensagens('!')
    } else if (countMensagens === '!') {
      setCountMensagens(0)
    }
  }, [sttChatCtx.chatMNLE, sttChatCtx.chatMNLP])

  function handleHome() {
    serverRouter('home', Services.ReturnLabelURL(userUCtx.usuario.estado, userUCtx.usuario.cidade))
  }

  function handleChat(event) {
    setAnchorEl(event.currentTarget)
    setModais(prev => ({ ...prev, chat: !modais.chat }))
  }

  function handleAgenda() {
    serverRouter('minha-agenda')
  }

  function handleConfig(event) {
    setAnchorEl(event.currentTarget)
    setModais(prev => ({ ...prev, config: !modais.config }))
  }

  function handleClose(key) {
    setAnchorEl(null)
    setModais(prev => ({ ...prev, [key]: false }))
  }

  return (
    <AuthBox>
      {modais.config && <MenuSettings open={modais.config} handleClose={handleClose} anchorEl={anchorEl} />}
      {modais.chat && <MenuChat open={modais.chat} handleClose={handleClose} anchorEl={anchorEl} />}
      <Tooltip title='Usuário Logado'>
        {/*Mostra o nome do usuário com o prefixo Olá, {Nome} */}
        <TitleName>Olá, {userUCtx.usuario.nome}</TitleName>
      </Tooltip>
      {!location.pathname.includes('cidade') && (
        <Tooltip title='Página Inicial'>
          <IconButton size='large' color='inherit' onClick={handleHome}>
            <IoHomeOutline color='white' size={25} />
          </IconButton>
        </Tooltip>
      )}
      {!location.pathname.includes('minha-agenda') && (
        <Tooltip title='Agendamentos'>
          <IconButton size='large' color='inherit' onClick={handleAgenda}>
            <BiCalendar color='white' size={25} />
          </IconButton>
        </Tooltip>
      )}
      {!pageChat && (
        <Tooltip title='Conversas'>
          <IconButton size='large' color='inherit' onClick={handleChat} sx={{ mr: 1 }}>
            <Badge badgeContent={countMensagens} color='error'>
              <ChatIcon />
            </Badge>
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title='Configurações'>
        <IconButton
          onClick={handleConfig}
          size='small'
          sx={{ mr: 1 }}
          aria-controls={modais.config ? 'account-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={modais.config ? 'true' : undefined}
        >
          <Avatar sx={{ width: 27, height: 27, bgcolor: 'white', color: '#FF7043' }}>{userUCtx.usuario.nome[0].toUpperCase()}</Avatar>
        </IconButton>
      </Tooltip>
    </AuthBox>
  )
}
